import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AiService } from 'src/app/business-service/ai/ai.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { MEAL_PLANS, ROUTE_CRAFT_TYPES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-dmc-package-route-craft',
  templateUrl: './dmc-package-route-craft.component.html',
  styleUrls: ['./dmc-package-route-craft.component.scss'],
})
export class DmcPackageRouteCraftComponent implements OnInit {

  @Input() packageId: any;
  @Input() storedFormData: any;

  @Input() editPackageId: any;

  @Input() packageDetailsFormData: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();

  noOfNights: number = 0;
  radioValue: string = ROUTE_CRAFT_TYPES.DAY_PLANNER;
  routeCraftForm!: FormGroup;
  freeTextForm!: FormGroup;
  sectionNote: string = "";
  acknowledgement: boolean = false;

  MEAL_PLAN = MEAL_PLANS;
  ROUTE_CRAFT_TYPES = ROUTE_CRAFT_TYPES
  // LOV data variables
  meals: any = [];

  hideAiSection: boolean = false;

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _lovDataService: LovDataService,
    private _responseNotificationService: ResponseNotificationService,
    private _dmcPackageService: DmcPackageService,
    private _aiService: AiService,
    private _validationService : InputValidationsService
  ) { }

  ngOnInit() {
    this.noOfNights = 0;
    this.updatePackageDetails();
    this.intilizeDayToDayTextForm();
    this.intilizeFreeTextForm();

    this._lovDataService.getLovData("Meals").subscribe((data) => {
      this.meals = data;
    });

    if(this.storedFormData){
      this.patchRouteCraftData(this.storedFormData);
    }

    this._globalService.roles$.subscribe((roles) => {
      if (roles) {
        const aiModule = roles.modules.find((module: any) => module.name === "Ai");
        if (!aiModule) {
          this.hideAiSection = true;
        }
        else
        {
          this.hideAiSection = false;
        }
      }
    })
  }

  updatePackageDetails() {
    if (this.packageDetailsFormData) {
      this.noOfNights = this.packageDetailsFormData.totalDays + 1
    } else {
      this._responseNotificationService.showMessage("Package Details is not entered", true)
    }
  }

  intilizeDayToDayTextForm() {
    this.routeCraftForm = this._fb.group({
      days: this._fb.array(this.createFreeTextDays())
    });
    this.routeCraftForm.markAsPristine();

    this.routeCraftForm.valueChanges.subscribe((value) => {
      this.routeCraftForm.markAsTouched();
      this.acknowledgement = false;
    })
  }

  createFreeTextDays() {
    let arr = [];
    for (let i = 0; i < this.noOfNights; i++) {
      arr.push(this._fb.group({
        day: ['', Validators.required],
        activities: ['', Validators.required],
        mealPlan: [null]
      }));
    }
    return arr;
  }

  intilizeFreeTextForm(){
    this.freeTextForm = this._fb.group({
      text: ['', [Validators.required]]
    });

    this.freeTextForm.valueChanges.subscribe((value) => {
      this.freeTextForm.markAsTouched();
      this.acknowledgement = false;
    });
  }

  get freeTextDays() {
    return this.routeCraftForm.get('days') as FormArray;
  }

  // Patch Data funtion
  patchRouteCraftData(formData: any) {
    this.radioValue = formData.selectedRouteType;

    this.routeCraftForm.patchValue({
      days: formData.dayToDayPlan
    }, { emitEvent: false });
    this.freeTextForm.patchValue(formData.freeText, { emitEvent: false });
    this.sectionNote = formData.note;
    this.acknowledgement = formData.acknowledgement || false;

    this.routeCraftForm.markAsPristine();
    this.freeTextForm.markAsPristine();
  }

  changeRadioValue(val: string) {
    this.radioValue = val;
    this.routeCraftForm.markAsTouched();
    this.freeTextForm.markAsTouched();
    this.routeCraftForm.markAsDirty();
    this.freeTextForm.markAsDirty();
    this.acknowledgement = false;
  }

  async onSubmit(): Promise<boolean> {
    if(this.radioValue === ROUTE_CRAFT_TYPES.DAY_PLANNER){
      // If day planner is selected
      if(this.routeCraftForm.valid && this.acknowledgement){
        let formData = await this.serializeFormData();
          
        return new Promise((resolve) => {
          this._dmcPackageService.addRouteCraft(formData).subscribe({
            next: (data: any) => {
              this.storeFormData.emit(data);
            },
            error: (error) => {
              console.error('Error saving package: ', error);
              this._responseNotificationService.showMessage("Error saving Route Craft", true);
              resolve(false);
            },
            complete: () => {
              this.routeCraftForm.markAsPristine();
              this._responseNotificationService.showMessage("Route Craft added successfully");
              resolve(true);
            }
          });
        });
      }else{
        this.triggerInvalidForm();
        return false;
      }
    }else if(this.radioValue === ROUTE_CRAFT_TYPES.FREE_TEXT){
      // If Free text is selected
      if(this.freeTextForm.valid && this.acknowledgement){
        let formData = await this.serializeFormData();
          
        return new Promise((resolve) => {
          this._dmcPackageService.addRouteCraft(formData).subscribe({
            next: (data: any) => {
              this.storeFormData.emit(data);
            },
            error: (error) => {
              console.error('Error saving package: ', error);
              this._responseNotificationService.showMessage("Error saving Route Craft", true);
              resolve(false);
            },
            complete: () => {
              this.freeTextForm.markAsPristine();
              this._responseNotificationService.showMessage("Route Craft added successfully");
              resolve(true);
            }
          });
        });
      }else{
        this.triggerInvalidForm();
        return false;
      }
    }else{
      return false;
    }
  }

  triggerInvalidForm(){
    this.routeCraftForm.markAllAsTouched();
    this.freeTextForm.markAllAsTouched();
    this._globalService.scrollToFirstInvalidControl();
    if(!this.acknowledgement){
      this._globalService.scrollToBottomOfContainer('.itinerary-model-container .itinerary-model-content-main .itinerary-model-content-inner .itinerary-model-content')
    }
    this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
    return false;
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  sectionNotesChanged(){
    this.routeCraftForm.markAsTouched();
    this.freeTextForm.markAsTouched();
    this.routeCraftForm.markAsDirty();
    this.freeTextForm.markAsDirty();
  }

  acknowledgementChanged(){
    this.routeCraftForm.markAsTouched();
    this.freeTextForm.markAsTouched();
    this.routeCraftForm.markAsDirty();
    this.freeTextForm.markAsDirty();
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  async serializeFormData(){
    const dayPlannerData = this.routeCraftForm.value;
    const freeTextData = this.freeTextForm.value;
    const formData = {
      packageId: this.packageId,
      id: this.storedFormData ? this.storedFormData.id : null,
      organizationId: this.storedFormData ? this.storedFormData.organizationId : null, 
      ownership: this.storedFormData ? this.storedFormData.ownership : null, 
      ownershipRole: this.storedFormData ? this.storedFormData.ownershipRole : null, 
      createDate: this.storedFormData ? this.storedFormData.createDate : null, 
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      daytodayPlan: dayPlannerData.days,
      freeText: freeTextData,
      selectedRouteType: this.radioValue,
      note: this.sectionNote,
      acknowledgement: this.acknowledgement
    }
    return formData;
  }

  formDataModified(): boolean {
    if(this.radioValue === ROUTE_CRAFT_TYPES.DAY_PLANNER){
      return  this.routeCraftForm.touched && (this.routeCraftForm.dirty || this.routeCraftForm.invalid);
    }else if(this.radioValue === ROUTE_CRAFT_TYPES.FREE_TEXT){
      return  this.freeTextForm.touched && (this.freeTextForm.dirty || this.freeTextForm.invalid);
    }else{
      return false;
    }
  }

  // Clear form funtions

  async clearAllRouteFormData() {
    if (await this._globalService.confirmActionPopup("Confirm to clear to data!")) {
      this.intilizeDayToDayTextForm();
    }
    this.routeCraftForm.markAsTouched();
  }

  // Generate with AI funtions

  generateAiRouteAndPatch() {
    let allDestinations = []

    for (let i = 0; i < this.packageDetailsFormData.destinations.length; i++) {
      let destination = this.packageDetailsFormData.destinations[i];
      let tempDest = {
        location: destination.location,
        days: destination.days,
        nights: destination.days
      };
      // If it's the last destination, add an extra day to the 'days' property
      if (i === this.packageDetailsFormData.destinations.length - 1) {
        tempDest.days += 1;
      }
      allDestinations.push(tempDest);
    }
    this._aiService.getAiGeneratedRouteCraftJson(allDestinations).subscribe((data) => {
      this.patchAiRouteCraft(data)
    }, (error) => {
      this._responseNotificationService.showMessage("RouteCraft generation failed. Please check the input data.", true);
    })
  }

  patchAiRouteCraft(aiData: any) {
    this.freeTextDays.clear()

    let totalNights = 0;
    for (let data of aiData) {
      if (!data.routeItineraryDayWise) {
        this._responseNotificationService.showMessage("RouteCraft generation failed. Please check the input data.", true);
        this.ngOnInit();
        return;
      }
      let keys = Object.keys(data.routeItineraryDayWise.days);
      for (let key of keys) {
        if (key === "note" || key === "notes") {
          continue;
        }
        let dayPlan = data.routeItineraryDayWise.days[key];
        let title: string = dayPlan.header;
        let description: string = dayPlan.content;

        // Replace all occurrences of '*' with an empty string
        title = title.replace(/\*/g, "");
        description = description.replace(/\*/g, "");

        totalNights++;
        let group = this._fb.group({
          day: [title, Validators.required],
          activities: [description, this._validationService.textEditorRequired()],
          mealPlan: [null]
        })

        this.freeTextDays.push(group)
      }
    }

    this.routeCraftForm.markAsDirty();
    this.routeCraftForm.markAsTouched();

    if (totalNights !== this.noOfNights) {
      this._responseNotificationService.showMessage("RouteCraft generation failed. Please check the input data.", true);
      this.intilizeDayToDayTextForm();
    }


  }

}
